// import Promise from 'pinkie-promise';
import authStore from '@/store/auth.js';
import MainStore from '@/store/userStore';
import UploadImgService, { PLATFORM_TYPE } from '@/utils/uploadImg.js';
import platformApi from '@/api/platformApi.js';
import { Indicator } from 'mint-ui';
import MapHelper from '../map.js';
import toast from '../../components/toast/store.js';
import Store from '../../store';
import Storage from '../storage';
import Toast from '../../components/toast';
// import Cookie from '../../utils/cookie';
import tools from '../tools';
// eslint-disable-next-line import/no-cycle
import WalletService from '../../service/walletService';
// eslint-disable-next-line import/no-cycle
import VipService from '../../service/vipService';
import alipay from '../platformUtils/alipay';
import params from '../param';

const CB_PREFIX = 'hbcallback';
let cbIndex = 0;
let hideLoadingTimer;
export default class BrowserCallNative {
  static setPageTitle({ title }) {
    if (title !== undefined) {
      document.title = title;
    }
    return Promise.resolve(true);
  }

  static alertMessage(data) {
    // TODO 使用通用msgStore进行控制
    // eslint-disable-next-line no-alert
    alert(data.message);
    return Promise.resolve(true);
  }

  static toastMessage({ message }) {
    toast.showToast(message);
  }

  static jumpTo() {
    // TODO { name: 'about' / 'home' / 'feedback' }
    throw new Error('not implement');
  }

  static goBack() {
    window.history.back();
  }

  static getCurrentLocation() {
    return MapHelper.getCurrentLocation();
  }

  static getCityInfo() {
    return MapHelper.getCityInfo();
  }

  static logout() {
    return this.invalidToken();
  }

  static showLoadingView() {
    throw new Error('not implement');
  }

  static hideLoadingView() {
    throw new Error('not implement');
  }

  static getUserInfo() {
    const cachedLoginInfo = this['.cached_login_info'];
    if (cachedLoginInfo && !tools.isPlainObject(cachedLoginInfo)) {
      return Promise.resolve(cachedLoginInfo);
    }
    let loginInfo = null;
    const loginResult = Storage.memory.login_result || Storage.getItem('login_result');
    loginInfo = loginResult || {};
    this['.cached_login_info'] = loginInfo;
    return Promise.resolve(loginInfo);
  }

  static jumpToHome() {
    Store.state.router.replace({ name: 'home' });
  }

  static invalidToken() {
    delete this['.cached_login_info'];
    Storage.removeItem('login_result');
    delete Storage.memory.login_result;
    authStore.reset();
    return Promise.resolve(true);
  }

  static getTokenAndKey() {
    const locationHref = window.location.href;
    const urlToken = params.get('token', locationHref);
    const urlTicket = params.get('ticket', locationHref);
    const urlUserGuid = params.get('userGuid', locationHref);
    if (urlToken && urlTicket) {
      return Promise.resolve({
        token: urlToken,
        ticket: urlTicket,
        userGuid: urlUserGuid || '',
      });
    }
    if (urlToken) {
      return Promise.resolve({
        token: urlToken,
        userGuid: urlUserGuid || '',
      });
    }
    const res = MainStore.getUserStore() || {};
    return Promise.resolve({ ...res });
  }

  static call(data) {
    window.location.href = `tel:${data.tel}`;
    return Promise.resolve(true);
  }

  static scanQRCode() {
    if (/wifiwx/i.test(navigator.userAgent)) {
      return new Promise((resolve, reject) => {
        if (window.WebViewJavascriptBridge) {
          if (!window.wxjsbInit) {
            window.WebViewJavascriptBridge.init();
            window.wxjsbInit = true;
          }
          window.WebViewJavascriptBridge.callHandler('scanQRCode', {}, (res) => {
            const result = typeof res === 'string' ? JSON.parse(res) : res;
            resolve(result.resultStr);
          });
        } else {
          reject(new Error('加载JsBridge失败'));
        }
      });
    }
    if (window.HBJsBridge) {
      cbIndex += 1;
      const cbName = CB_PREFIX + cbIndex;
      return new Promise((resolve, reject) => {
        window[cbName] = (res) => {
          if (!res || typeof res !== 'string') {
            reject(new Error('没有返回结果或者结果不为String'));
          }
          const jsonRes = JSON.parse(res);
          if (jsonRes.success) {
            resolve(jsonRes.result);
          } else {
            reject(new Error(jsonRes.msg || '未知错误'));
          }
        };
        window.HBJsBridge.scanQR(cbName);
      });
    }

    // return Promise.resolve('http://c3x.me/?n=2100000032');
    throw new Error('not implement');
  }

  static vibrate(opt) {
    if (navigator.vibrate) {
      navigator.vibrate((opt && opt.duration) || 500);
    }
    return Promise.resolve();
  }

  static chargeWallet(options) {
    return WalletService.chargeWalletAlipay(options).then((data) => {
      alipay.pay(data.orderInfo);
    });
  }

  static chargeDeposit(options) {
    return WalletService.chargeDepositAlipay(options).then((data) => {
      alipay.pay(data.orderInfo);
    });
  }

  static chargeVip(options) {
    return VipService.chargeVipAlipay(options).then((data) => {
      alipay.pay(data.orderInfo);
    });
  }

  static getNativePhoneNo() {
    return Promise.resolve('');
  }

  static callNative(name, data) {
    if (!this[name]) {
      return Promise.reject(new Error(`${name}: 功能暂时无法使用`));
    }

    return this[name](data);
  }

  /**
   * * 链接跳转
   * @param {string} url跳转链接
   */
  static navigateTo(url) {
    window.location.href = url;
  }

  /**
   * 显示loading
   */
  static showLoading() {
    Indicator.open();
  }

  /**
   * 隐藏loading
   * @param {longint} delayTime 延迟隐藏毫秒数
   */
  static hideLoading({ delayTime }) {
    clearTimeout(hideLoadingTimer);
    hideLoadingTimer = setTimeout(() => { Indicator.close(); }, delayTime || 500);
  }

  static callphotograph(onlyUseCamera) {
    return new Promise((resolve, reject) => {
      let fileInput = document.querySelector('.outside-file-input');
      if (fileInput) {
        document.body.removeChild(fileInput);
      }
      fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = 'image/*';
      if (onlyUseCamera) {
        fileInput.capture = 'camera';
      }
      if (!fileInput.classList.contains('outside-file-input')) {
        fileInput.classList.add('outside-file-input');
      }
      const callback = () => {
        if (!fileInput.files || fileInput.files.length < 1) {
          reject();
          return;
        }
        const filetype = fileInput.files[0].type;
        const fileSize = fileInput.files[0].size;
        const reg = /^(image)/;
        if (!reg.test(filetype)) {
          Toast.show('请选择照片').catch((v) => reject(v));
          return;
        }
        const reader = new FileReader();
        reader.onload = async () => {
          try {
            const scale = fileSize > (500 * 1024) ? (500 * 1024) / fileSize : 1;
            const compressImg = await UploadImgService.imgCompress(reader.result, scale, filetype);
            resolve(compressImg.replace(/data:image\/.*;base64,/, ''));
          } catch (e) {
            Toast.show('图片上传发生错误,请稍后重试').catch((v) => reject(v));
            reject(e);
          }
        };
        reader.readAsDataURL(fileInput.files[0]);
      };

      fileInput.onchange = callback;
      fileInput.click();
      document.body.appendChild(fileInput);
    });
  }

  static async chooseImageAndUploadImage(Params) {
    let beforeUpload;
    let afterUpload;
    if (Params) {
      ({
        beforeUpload,
        afterUpload,
      } = Params);
    }
    const onlyUseCamera = !!(Params && Params.onlyUseCamera);

    const relFile = await this.callphotograph(onlyUseCamera);

    if (beforeUpload) {
      beforeUpload();
    }
    try {
      const imageUrl = await platformApi.uploadImage({
        file: relFile || '',
        image: 40,
        type: PLATFORM_TYPE.H5,
      });

      if (afterUpload) {
        afterUpload();
      }
      return imageUrl.url;
    } catch (error) {
      if (afterUpload) {
        afterUpload();
      }
      return '';
    }
  }
}
